import { LicenseWidget } from './license-widget.jsx';

/**
 * Settings → License tab. Thin wrapper around <LicenseWidget> so the KMS
 * license card sits on its own page rather than mixed in with system
 * preferences. Visible to all signed-in users; the Renew button inside
 * the widget is admin-only.
 */
export function LicenseTab({ currentUser }) {
  return (
    <div className="space-y-6">
      <LicenseWidget currentUser={currentUser} />
    </div>
  );
}
